import { render, staticRenderFns } from "./shopSetting.vue?vue&type=template&id=d4d2e460&"
import script from "./shopSetting.vue?vue&type=script&lang=js&"
export * from "./shopSetting.vue?vue&type=script&lang=js&"
import style0 from "./shopSetting.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports